'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useExploreViverseData } from '@/app/[locale]/(worlds)/components/useExploreViverseData';
import { LoadingDots } from '@/components/LoadingDots';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { ViverseWorldCardSkeleton } from '@/components/ViverseWorldCardSkeleton';
import { useConfigsContext } from '@/context/ConfigsContext';
import useHash from '@/hooks/useHash';
import { useLoadMore } from '@/hooks/useLoadMore';
import { useSearchParamsSchema } from '@/hooks/useSearchParamsSchema';
import { getCardType } from '@/lib/viverse-world-card';
import { ViverseWorldCardType } from '@/types/viverse-world-card';
const CARD_GRID = 'grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6 1.5xl:grid-cols-4';
type ExploreViverseCardGridProps = {
  activeTag: string;
  activeCardType: ViverseWorldCardType | null;
};
export default function ExploreViverseCardGrid(t0) {
  const $ = _c(38);
  const {
    activeTag,
    activeCardType
  } = t0;
  const {
    store
  } = useConfigsContext();
  const {
    sort,
    device,
    type
  } = useSearchParamsSchema();
  const hash = useHash();
  const htcToken = store?.credentials?.htcToken;
  let t1;
  if ($[0] !== activeTag || $[1] !== device || $[2] !== htcToken || $[3] !== sort || $[4] !== type) {
    t1 = {
      activeTag,
      htcToken,
      sort,
      device,
      type
    };
    $[0] = activeTag;
    $[1] = device;
    $[2] = htcToken;
    $[3] = sort;
    $[4] = type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    allRooms,
    enableLoadMore,
    enableRecommendWorlds,
    isBackNav,
    pagination,
    showSkeletons,
    skeletonCount
  } = useExploreViverseData(t1);
  let t2;
  if ($[6] !== enableLoadMore || $[7] !== pagination) {
    t2 = {
      enabled: enableLoadMore,
      ...pagination
    };
    $[6] = enableLoadMore;
    $[7] = pagination;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const loadMoreRef = useLoadMore(t2);
  let t3;
  let t4;
  if ($[9] !== hash || $[10] !== isBackNav) {
    t3 = () => {
      if (isBackNav || hash !== "#explore-viverse") {
        return;
      }
      const element = document.querySelector("#explore-viverse");
      if (!element) {
        return;
      }
      element.scrollIntoView({
        behavior: "smooth"
      });
    };
    t4 = [hash, isBackNav];
    $[9] = hash;
    $[10] = isBackNav;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== activeCardType || $[14] !== allRooms || $[15] !== enableRecommendWorlds || $[16] !== htcToken) {
    let t6;
    if ($[18] !== activeCardType || $[19] !== enableRecommendWorlds || $[20] !== htcToken) {
      t6 = world => <ViverseWorldCard key={world.id} info={world} data-room-id={world.id ? `ev:${world.id}` : undefined} className="h-auto p-0" imageClassName="aspect-video w-full object-cover" hideLiked={!htcToken || enableRecommendWorlds} hidePremiumBadge={false} cardType={activeCardType ?? getCardType(world.content_type)} />;
      $[18] = activeCardType;
      $[19] = enableRecommendWorlds;
      $[20] = htcToken;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t5 = allRooms.map(t6);
    $[13] = activeCardType;
    $[14] = allRooms;
    $[15] = enableRecommendWorlds;
    $[16] = htcToken;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[22] !== showSkeletons || $[23] !== skeletonCount) {
    t6 = showSkeletons && Array.from({
      length: skeletonCount
    }).map(_temp);
    $[22] = showSkeletons;
    $[23] = skeletonCount;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className={CARD_GRID}>{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== enableLoadMore || $[29] !== loadMoreRef) {
    t8 = enableLoadMore && <div ref={loadMoreRef} className="h-1" />;
    $[28] = enableLoadMore;
    $[29] = loadMoreRef;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== allRooms.length || $[32] !== pagination.isValidating) {
    t9 = pagination.isValidating && allRooms.length > 0 && <LoadingDots />;
    $[31] = allRooms.length;
    $[32] = pagination.isValidating;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t10 = <div className="px-4 lg:px-6">{t7}{t8}{t9}</div>;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}
function _temp(_, index) {
  return <ViverseWorldCardSkeleton key={`skeleton-${index}`} className="aspect-video h-auto p-0" />;
}